import { render, staticRenderFns } from "./OpportunityAdminPanel.vue?vue&type=template&id=52928b24&scoped=true"
import script from "./OpportunityAdminPanel.vue?vue&type=script&lang=js"
export * from "./OpportunityAdminPanel.vue?vue&type=script&lang=js"
import style0 from "./OpportunityAdminPanel.vue?vue&type=style&index=0&id=52928b24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52928b24",
  null
  
)

export default component.exports